import { useCallback, useState } from 'react';
import type { QuoteError } from '../types/quote.types';

export const useQuoteErrorModal = () => {
    const [quoteError, setQuoteError] = useState<QuoteError | null>(null);
    const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

    const openErrorModal = useCallback((error: QuoteError) => {
        setQuoteError(error);
        setIsErrorModalOpen(true);
    }, []);

    const closeErrorModal = useCallback(() => {
        setIsErrorModalOpen(false);
        setQuoteError(null);
    }, []);

    const hideErrorModal = useCallback(() => setIsErrorModalOpen(false), []);

    const clearQuoteError = useCallback(() => setQuoteError(null), []);

    return { quoteError, isErrorModalOpen, openErrorModal, closeErrorModal, hideErrorModal, clearQuoteError };
};
